import Log from "@/utils/Log";
import Vue from "vue";

const WclList = () => require("@/components/forms/mixins/plm/WclList");
const DocumentsList = () => require("@/components/forms/mixins/plm/DocumentsList.vue");


const mixins = {
    default: {},
    plm: {
        WCL_LIST: WclList,
        DOCUMENTS_LIST: DocumentsList
    }
}


let mixinsInitialized = false;

export async function initMixins() {
    if (mixinsInitialized) {
        return;
    }
    mixinsInitialized = true;

    for (const g in mixins) {
        for (const k in mixins[g]) {
            mixins[g][k] = (await mixins[g][k]()).default;
        }
    }
}

/** Map<String, Class> */
let componentStore = null;


export function getMixinComponentClass(group, name, router) {
    if (!group) {
        group = "default";
    }

    let key = `${group}-${name}`;

    if (componentStore) {
        if (componentStore.has(key)) {
            return componentStore.get(key);
        }
        Log.fatal("mixin component not found:" + key);
        throw new Error("mixin component not found:" + key);
    }

    componentStore = new Map();
    for (const grp in mixins) {
        for (const nm in mixins[grp]) {
            let cKey = `${grp}-${nm}`;
            let ComponentClass = Vue.extend({...mixins[grp][nm], router});
            componentStore.set(cKey, ComponentClass);
        }
    }

    return getMixinComponentClass(group, name);
}